import { render, staticRenderFns } from "./CurrentCom.vue?vue&type=template&id=100916ca&scoped=true"
import script from "./CurrentCom.vue?vue&type=script&lang=js"
export * from "./CurrentCom.vue?vue&type=script&lang=js"
import style0 from "./CurrentCom.vue?vue&type=style&index=0&id=100916ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100916ca",
  null
  
)

export default component.exports